import { ModelCatalogFilterForm } from "../types/motorAtlasCatalogTypes";

type Entry<V> = { value: V; timestamp: number };
export function createCacheLRU<V>(max = 20, ttlMs = 0) {
  const map = new Map<string, Entry<V>>()
  function get(key: string): V | undefined {
    const e = map.get(key)
    if (!e) return;
    if (ttlMs && Date.now() - e.timestamp > ttlMs) {
      map.delete(key)
      return
    }
    map.delete(key)
    map.set(key, e)
    return e.value
  }

  function set(key: string, value: V) {
    if (map.has(key)) map.delete(key)
    map.set(key, { timestamp: Date.now(), value })
    if (map.size > max) {
      const firstKey = map.keys().next().value as string;
      map.delete(firstKey)
    }
  }

  const clear = () => map.clear();
  const deleteKey = (key: string) => map.delete(key)

  return { get, set, clear, deleteKey }
}

export function serializeFilters(v: ModelCatalogFilterForm): string {
  const norm = {
    ...v,
    fuel: (v.fuelType ?? []).slice().sort(),
    gearBox: (v.gearbox ?? []).slice().sort(),
    body: (v.bodyType ?? []).slice().sort(),
    driveWheel: (v.driveType ?? []).slice().sort(),
  };

  // Remove empty/undefined
  Object.keys(norm).forEach((k) => {
    const val = norm[k as keyof ModelCatalogFilterForm];
    let shouldDeleteKey = false
    if (val === null || val === undefined) {
      shouldDeleteKey = true
    } else if (Array.isArray(val) && val.length === 0) {
      shouldDeleteKey = true
    } else if (typeof val === "object" && !Array.isArray(val) && (!val.from || !val.to)) {
      shouldDeleteKey = true
    }

    if (shouldDeleteKey) {
      delete (norm as any)[k];
    }
  });

  return JSON.stringify(norm);
}
